import { describeTarget } from './naming.ts'
import { describeContext } from './context.ts'
import type { LoggableEvent } from '../recorder.ts'

export interface UiEventsOptions {
  document: Document
  log: (event: LoggableEvent) => void
}

const IGNORE_SELECTOR = '[data-sat-ignore]'

/** Logs clicks and form submits as steps. Capture phase so a handler that stops propagation still counts. */
export function startUiEvents({ document, log }: UiEventsOptions): () => void {
  const record = (event: Event) => {
    const target = event.target
    if (!(target instanceof Element)) return
    if (target.closest(IGNORE_SELECTOR)) return
    const { name, role } = describeTarget(target)
    log({ type: 'step', name, role, ...describeContext(target) })
  }
  document.addEventListener('click', record, true)
  document.addEventListener('submit', record, true)
  return () => {
    document.removeEventListener('click', record, true)
    document.removeEventListener('submit', record, true)
  }
}
